import "./home.css";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link, useNavigate } from "react-router-dom";
import { apiCall, failedMessage } from "../../utils/httpClient";
import apiEndPoint from "../../utils/apiEndPoint";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import { Image } from "react-bootstrap";
import TemplateSlider from "./components/templateslider";
import HomepageMap from './homepagemap.png';
import RealtimeIcon from './icon1.png';
import RealtimeIconTwo from './icn2.png';
import RealtimeIconThree from './icn3.png';
import RealtimeIconFour from './icn4.png';
import RealtimeIconFive from './icn5.png';
import RealtimeIconSix from './icn6.png';
import RealtimeIconSeven from './icn7.png';
import RealtimeIconEight from './icn8.png';
import OurMission from './ourmission.png';
import ProfileMission from './profile.png';
import SilloutVideo from './silloutt.gif';
import { isEmpty } from "utils/utils";
import { useMediaQuery } from 'react-responsive';
import AnimatedText from "./components/animatedtextprofess";
import { FaSearch } from "react-icons/fa";
import HomeTemplateGallery from "./hometemplategallery";
import HomeCategoryModal from "./homecategorymodal";
import { FaBars, FaTimes } from "react-icons/fa";
function Home() {
  const boxRef = useRef(null);
  const megaMenuRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [templatesList, setTemplatesList] = useState([]);
  const [base_url, setbaseurl] = useState([]);
  const [height, setHeight] = useState(500);
  const [isLoading, setLoading] = useState(true);
  const [searchTemplate, setSearchTemplate] = useState('');
  const [selectCategoryId, setSelectCategoryId] = useState('');
  // const [isAuth, setIsAuth] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [searchCategory, setSearchCategory] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);


  const reviews = [
    { _id: 1, text: "abc" },
    { _id: 2, text: "def" },
    { _id: 3, text: "ghi" },
    { _id: 4, text: "jkl" },
    { _id: 5, text: "mno" },
    { _id: 6, text: "pqr" },
    { _id: 7, text: "stu" },
    { _id: 8, text: "vwx" },
    { _id: 9, text: "yza" },
  ];
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setHeight(200);  // Set height for smaller screens
      } else {
        setHeight(500);  // Default height
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();  // Set initial height on mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // useEffect(() => {
  //   // handleGetCategory();
  //   const authData = loadFromLocalStorage("AUTH_DATA");
  //   if (authData?.token) {
  //     setIsAuth(true)
  //   }
  // }, []);
  useEffect(() => {
    getTemplatesList();
  }, []);
  const getTemplatesList = async (item) => {
    // let params = {};
    // const { data } = await apiCall("post", apiEndPoint.GETTEMPLATE);
    // if (data.status === 200) {
    //   setTemplatesList([...Array.from(data.data.reduce((m, o) => m.set(o['category_id'], o), new Map())
    //     .values())]);
    //   setbaseurl(data.base_url);
    // } else {
    //   setTemplatesList([]);
    // }
    // setLoading(false)
  };
  const handleGetCategory = async (cat_name) => {
    if (!isEmpty(cat_name)) {
      const params = { limit: 20, offset: 0, category_name: cat_name }
      const { data } = await apiCall("post", apiEndPoint.GETCATEGORY, params);
      if (data.status === 200) {
        setCategories(data.data);
      } else {
        setCategories([]);
        // failedMessage(data.message);
      }
    } else {
      setCategories([]);
    }
  };
  const navigate = useNavigate();
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
    }
  }

  const handleSelectCategory = (item) => {
    setSearchTemplate(item?.category_name)
    setCategories([])
    setSelectCategoryId(item?._id)
  }

  // Function to handle clicks outside the box
  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setCategories([])
    }
  };
  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Clean up the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleAllTemplateData = () => {
    setSearchCategory('')
    setSelectCategoryId('')
    setCurrentPage(0)
    localStorage.setItem('selectCategoryId', '')
    getTemplatesList(searchCategory, 0)
  }
  const [index, setIndex] = useState(0);
  const text =
    "Search for Types of Businesses: Personal Resume - Freelancer - Portfolio/Personal Portfolio - Student/kid/Child Portfolio - Web Developer - Graphic Designer - Social Media Manager - Game Developer - Software Developer - Computer Programmer - Mobile App Developer - Director/Principal/Any Top Designation - Principal - Owner - Language Trainer - Life Coach Trainer - Gym Trainer - Recipe Blogger - Travel Blogger - Fashion Blogger - Cook/Chef - Blogger - Athlete - Yoga Trainer - CA (Chartered Accountant) - Jewellers - Dry Cleaners/Laundry Specialist - Carpenter - Cleaning Service Provider - Baker - Academic Co-ordinator - Professor - Teacher - Online Tutor - Detective - Dietician/Nutritionist - Health Coach/Personal Coach - Nurse/Medical - Assistant - Plumber - Electrician - Doctor - Physician - Surgeon - Therapist - Any Counsellor/Academic Counsellor/Relationship Counsellor - Psychologist - Dentist - Paediatrician - Cardiologist - Gynaecologist - Optometrist - Veterinarian/Pet Care Specialist - Psychiatrist - Animal Trainer - Dermatologist - Anaesthesiologist - Chemist - Optician - Magician - Musician - Mechanic - Locksmith - Scientist - PHD - Researcher - AC Repair Service Provider - Geologist - Administrative Assistant - Police Inspector - Pilot - Artist - Architect - Sports Trainer - Bartender - Banker - Video Editor - Travel Agent - Music Teacher - Politician - Engineer - Model - Actor/Actress - Singer - DJ (Disc Jockey) - Industrialist - Business Consultant - Technical Writer - Journalist - Librarian - Wedding Planner - Wedding Invitation Website - My Memories Website - Tattoo Master - Event Planner - Economist - Business Analyst - Accountant - Public Relationship Manager - Sales Manager - Dance Teacher - Dance Studio/Dance Class - Dancer - Beautician - Parlour/Salon - Cosmetologist - Make Up Artist - Content Writer - Copywriter - Barber - Hairdresser/Hairstylist - Interior Designer/Home Decor Specialist - Insurance Agent - Fashion Designer - Fitness Trainer/Instructor - Financial Advisor/Investment Specialist - Counselor - Lawyer - Judge - Farmer - Vegetable Dealer - Organic Vegetable Dealer - Agriculture Firm - Movers & Packers - Any Industry - Gardener - Nursery - Battery Shop - Wedding Planner Company - Real Estate Agent/Broker - Tax Consultant - Tour Guide - Translator/Interpreter - Photographer - Customer Service Representative (CSR) - Florist - Bookkeeper - Auditor - Author - Editor - Any company/Agency/Business - Web Development Agency - IT Company - Digital Marketing Agency - Manager - Branding Company - Marketing Agency - Music Company - Lab Technician - School - College/University/School - Hotel - Restaurant - Fashion Boutique - Cafe - Kinder Garden - Coaching Class - Hospital - Clinic - Gym - Spa Shop - Caretaker/Elderly Home - Orphanage - Law Firm - Construction Company - Real Estate Agency - Tailor - Advertising Company";

  const [placeholderText, setPlaceholderText] = useState(
    "Search for Types of Businesses: Plumbers - Yoga - Movers - Ride - Dog Groomer - Handyman - Wedding Planner - Courses - Childcare - Upholstery Repair Service - Dance Classes - House Cleaner"
  );
  const isSmallScreen = useMediaQuery({ maxWidth: 576 });

  const pcustomwemake = {
    fontSize: isSmallScreen ? 14 : 18,
    fontWeight: 500,
    color: isSmallScreen ? '#000' : '#83817f',
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderText((prev) => text.substring(index, text.length) + text.substring(0, index));
      setIndex((prevIndex) => (prevIndex + 1) % text.length);
    }, 200); // Adjust speed of scrolling

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [index, text]);

  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        megaMenuRef.current &&
        !megaMenuRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        setIsMegaMenuOpen(false);
      }
    }

    if (isMegaMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMegaMenuOpen]);

  return (
    <div className="home-app">
      <section className="welcome-section">
        <Container>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
              <div className="text-center-sm">
                <h3 className="animate__animated animate__bounce" style={{ maxWidth: 500 }}>
                  {languageData?.getProfessionalWebsiteFor}
                </h3>
                <div style={{ maxWidth: 350, marginTop: 20, marginBottom: 20 }}>
                  <p style={{ textAlign: 'left', marginBottom: '5px' }}>
                    {languageData?.justAt}
                  </p>
                  <p style={{ color: '#ff671f', margin: 0, fontFamily: 'garet', fontSize: 50, fontWeight: 700, textAlign: 'center', lineHeight: '35px' }}>₹ 10</p>
                  <p style={{ textAlign: 'end', margin: 0, marginLeft: 10 }}>
                    {languageData?.perDay}
                  </p>
                </div>
                <button style={{ marginTop: 20, marginBottom: 20 }} onClick={handleShow}
                  // onClick={() => { navigate(isAuth ? "/categories" : "/login");}                                   }
                  className="btn play-btn"
                >
                  {languageData?.playVideo} <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                </button>{" "}
                <Modal show={show} onHide={handleClose} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <iframe width="100%" height="400" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=ne27j8Gm_bu_-fg1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </Modal.Body>
                </Modal>
                <br /> <br /> <br />
              </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <img src="https://i.ibb.co/ws4fpt6/anew.png" alt="anew" border="0" />
            </Col>
            <Container>
              <Row style={{ alignItems: 'center' }}>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <div className="d-flex gutter-space-2 justify-content-center justify-content-md-start" style={{ width: '100%' }}>
                    <div>
                      <img style={{ width: 100 }} src="https://en-media.thebetterindia.com/uploads/2014/10/Make-In-IndiaLogo.jpg" alt="" />
                    </div>
                    <div className="ms-1 adj-widinmadeinindia">
                      <p style={{ margin: 0, fontSize: 13, fontWeight: 600, textAlign: 'left' }}>
                        {languageData?.madeInIndia}
                      </p>
                      <p style={{ margin: 0, fontSize: 13, fontWeight: 600, textAlign: 'left' }}>
                        {languageData?.forThePeopleOfIndia}
                      </p></div>
                  </div>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <div className="d-md-flex align-items-center text-center text-md-start" style={{ width: '100%' }}>
                    <div>
                      <p style={{ margin: 0, fontSize: 13, fontWeight: 600, minWidth: '200px', textAlign: 'center' }}>
                        {languageData?.availtodownload}
                      </p></div>
                    <div className="text-center text-md-start">
                      <img
                        src="https://i.ibb.co/yFfcpzg2/Daco-4108569.png"
                        alt="download_app"
                        className="responsive-imgdownloadmobile"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Row>
        </Container>
      </section>
      <section className="services-section">
        <div className="container text-center">
          <h2 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', maxWidth: 800, textAlign: 'center', margin: 'auto' }}>
            {languageData?.wideSelectionOfTemplates}
            <AnimatedText />
          </h2>
          <br />
          <p style={{ fontSize: 16, fontWeight: 500, maxWidth: 500, margin: 'auto', color: '#83817f' }}>{languageData?.withOverProfessionBusiness}</p>
          <br />
          {
            selectCategoryId && (
              <Button
                variant="link"
                onClick={() => {
                  handleAllTemplateData();
                  setIsMegaMenuOpen(false);
                  setSelectCategoryId('');
                  setSelectedCategoryId(null);
                }}
                style={{
                  backgroundColor: '#eee',
                  color: '#222222',
                  borderRadius: '50px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 600,
                  padding: '5px 15px',
                  whiteSpace: 'nowrap',
                  WebkitUserSelect: 'none',
                  userSelect: 'none',
                  textDecoration: 'none',
                  transition: 'background-color 0.3s ease',
                  border: '1px solid #ff671f',
                }}
              >
                <FaTimes /> {languageData?.clear}
              </Button>

            )
          }
          <div style={{marginTop: '2rem' }}>
            <div style={{ display: 'flex', alignItems: "center", width: '100%', gap: '20px' }}>
              <div style={{ position: 'relative' }}>
                <div className="tab-slider-container" style={{ width: "100%", position: 'relative' }}>
                  <Button
                    variant="primary"
                    ref={toggleButtonRef}
                    onClick={() => {
                      setIsMegaMenuOpen(prev => !prev);
                      handleAllTemplateData();
                    }}
                    style={{
                      width: "35px",
                      height: "35px",
                      padding: 0,              // remove default padding for accurate sizing
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isMegaMenuOpen ? (
                      <FaTimes style={{ fontSize: "15px" }} />
                    ) : (
                      <FaBars style={{ fontSize: "15px" }} />
                    )}
                  </Button>
                  {isMegaMenuOpen && (
                    <div className="mega-menu-box" ref={megaMenuRef}>
                      <HomeCategoryModal setSelectCategoryId={setSelectCategoryId}
                        setCurrentPage={setCurrentPage}
                        // searchCategory={searchCategory}
                        handleAllTemplateData={handleAllTemplateData}
                        languageData={languageData} setIsMegaMenuOpen={setIsMegaMenuOpen} setSearchTemplate={setSearchTemplate} />
                    </div>
                  )}
                </div>

              </div>
              <div style={{ position: 'relative', width: '100%' }}>
                <input
                  onChange={(e) => {
                    setSearchTemplate(e.target.value);
                    handleGetCategory(e.target.value);
                    setSelectCategoryId('')
                  }}
                  type="text"
                  id="marqueeInput"
                  className="form-control"
                  value={searchTemplate}
                  style={{
                    paddingTop: 11,
                    paddingBottom: 11,
                    paddingLeft: '15px',
                    paddingRight: '40px', // make space for icon
                    borderRadius: '50px',
                    width: '100%',
                    fontWeight: 500,
                    color: 'rgb(170, 170, 170)',
                    backgroundColor: 'transparent',
                  }}
                />
                <span style={{
                  position: 'absolute',
                  // right: 15,
                  top: '50%',
                  // borderLeft: '1px solid #ccc',
                  transform: 'translateY(-50%)',
                  color: '#fff',
                  width: '44px',
                  borderRadius: '0px 50px 50px 0px',
                  background: '#ff671f', right: '1px', zIndex: 3,
                  // pointerEvents: 'none' 
                  height: '42px', paddingTop: '7px',
                  cursor: "pointer"

                }}>
                  <FaSearch
                    style={{
                      // position: 'absolute',
                      // right: 15,
                      // top: '50%',
                      // transform: 'translateY(-50%)',
                      color: '#fff',
                      // background: '#fff',
                      // pointerEvents: 'none',



                    }}

                  />
                </span>
                {searchTemplate === '' && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '10px',
                      left: '2%', // aligns with input's padding/margin
                      pointerEvents: 'none',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <div
                      style={{
                        color: 'rgb(170, 170, 170)',
                        fontWeight: 300,
                      }}
                    >
                      {/* Search for Types of Businesses : Personal Resume - Freelancer - Portfolio/Personal Portfolio - Student/Kid/Child Portfolio - Web Developer - Graphic Designer -
                        Social Media Manager - Game Developer - Software Developer - Computer Programmer - Mobile App Developer - Director/Principal/Any
                        Top Designation - Principal - Owner - Language Trainer - Life Coach Trainer - Gym Trainer - Recipe Blogger - Travel Blogger -
                        Fashion Blogger - Cook/Chef - Blogger - Athlete - Yoga Trainer - CA (Chartered Accountant) - Jewellers - Dry Cleaners/Laundry
                        Specialist - Carpenter - Cleaning Service Provider - Baker - Academic Co-ordinator - Professor - Teacher - Online Tutor - Detective -
                        Dietician/Nutritionist - Health Coach/Personal Coach - Nurse/Medical Assistant - Plumber - Electrician - Doctor - Physician - Surgeon -
                        Therapist - Any Counsellor/Academic Counsellor/Relationship Counsellor - Psychologist - Dentist - Paediatrician - Cardiologist -
                        Gynaecologist - Optometrist - Veterinarian/Pet Care Specialist - Psychiatrist - Animal Trainer - Dermatologist - Anaesthesiologist -
                        Chemist - Optician - Magician - Musician - Mechanic - Locksmith - Scientist - PHD - Researcher - AC Repair Service Provider - Geologist -
                        Administrative Assistant - Police Inspector - Pilot - Artist - Architect - Sports Trainer - Bartender - Banker - Video Editor - Travel
                        Agent - Music Teacher - Politician - Engineer - Model - Actor/Actress - Singer - DJ (Disc Jockey) - Industrialist - Business Consultant -
                        Technical Writer - Journalist - Librarian - Wedding Planner - Wedding Invitation Website - My Memories Website - Tattoo Master - Event
                        Planner - Economist - Business Analyst - Accountant - Public Relationship Manager - Sales Manager - Dance Teacher - Dance Studio/Dance
                        Class - Dancer - Beautician - Parlour/Salon - Cosmetologist - Make Up Artist - Content Writer - Copywriter - Barber -
                        Hairdresser/Hairstylist - Interior Designer/Home Decor Specialist - Insurance Agent - Fashion Designer - Fitness Trainer/Instructor -
                        Financial Advisor/Investment Specialist - Counselor - Lawyer - Judge - Farmer - Vegetable Dealer - Organic Vegetable Dealer - Agriculture
                        Firm - Movers & Packers - Any Industry - Gardener - Nursery - Battery Shop - Wedding Planner Company - Real Estate Agent/Broker - Tax
                        Consultant - Tour Guide - Translator/Interpreter - Photographer - Customer Service Representative (CSR) - Florist - Bookkeeper - Auditor -
                        Author - Editor - Any Company/Agency/Business - Web Development Agency - IT Company - Digital Marketing Agency - Manager - Branding
                        Company - Marketing Agency - Music Company - Lab Technician - School - College/University/School - Hotel - Restaurant - Fashion Boutique -
                        Cafe - Kinder Garden - Coaching Class - Hospital - Clinic - Gym - Spa Shop - Caretaker/Elderly Home - Orphanage - Law Firm - Construction
                        Company - Real Estate Agency - Tailor - Advertising Company. */} Type your niche
                    </div>

                  </div>
                )}
                {categories.length > 0 && (
                  <div
                    style={{
                      width: '100%',
                      marginTop: '0px',
                      position: 'absolute',
                      zIndex: 9,
                    }}
                  >
                    <div
                      ref={boxRef}
                      style={{
                        textAlign: 'left',
                        padding: '7px 0rem',
                        background: 'white',
                        border: '1px solid #bfbfbf',
                        borderRadius: '6px',
                        marginTop: '0px',
                        width: 'fit-content',
                      }}
                    >
                      <ul
                        style={{
                          listStyle: 'none',
                          padding: 0,
                          margin: 0,
                          maxHeight: '300px',
                          overflow: 'auto',
                        }}
                      >
                        {categories.map((item, i) => (
                          <li
                            key={i}
                            style={{
                              cursor: 'pointer',
                              padding: '3px 13px',
                            }}
                            className="catListHome"
                            onClick={() => handleSelectCategory(item)}
                          >
                            {item?.category_name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>

          {/* <TemplateSlider searchTemplate={searchTemplate} selectCategoryId={selectCategoryId} /> */}
          <HomeTemplateGallery searchTemplate={searchTemplate} selectCategoryId={selectCategoryId} setSelectCategoryId={setSelectCategoryId} selectedCategoryId={selectedCategoryId} setSelectedCategoryId={setSelectedCategoryId} />
        </div>
      </section>
      <section className="services-section">
        <div className="container text-center">
          <h2 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', textAlign: 'center', margin: 'auto' }}>
            {languageData?.howToCreateStunningWebsiteWithUs}
          </h2>
          <br />
          <p style={{ fontSize: 16, fontWeight: 500, maxWidth: 800, margin: 'auto', color: '#83817f' }}>{languageData?.beItCvorProfessionalLookingWebsite}.</p>
          <br />
          <button style={{ marginTop: 20, marginBottom: 20 }} onClick={handleShow}
            // onClick={() => {
            //   navigate(isAuth ? "/categories" : "/login");
            // }}
            className="btn play-btn"
          >
            {languageData?.watchVideo} <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
          </button>{" "}
          <div style={{ textAlign: 'center', background: 'linear-gradient(to bottom, #fff,  #fff, #ff671f)', borderRadius: 40, height: `${height}px` }}>
            <img src={HomepageMap} alt="homepagemap" width={'80%'} />
          </div>
        </div>

      </section>
      <section className="services-section">
        <div className="container text-center">
          <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', maxWidth: 600, textAlign: 'center', margin: 'auto' }}>
            {languageData?.why} <span style={{ color: '#ff671f' }}>{languageData?.my}</span><span style={{ color: '#06038d' }}>{languageData?.digital}</span><span style={{ color: '#046a38' }}>{languageData?.india} </span>  {languageData?.appIsTheBest}
          </h3>
          <br />
          <p style={{ fontSize: 16, fontWeight: 500, maxWidth: 800, margin: 'auto', color: '#83817f' }}>
            {languageData?.creatingProfessionalAndVisually}
          </p>
          <br />
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIcon} alt="icon" />
                <br /> <br />
                <h6>{languageData?.realTimeContentUpdates}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>
                  {languageData?.updateYourWebsiteContentAnytime}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconTwo} alt="icon" />
                <br /> <br />
                <h6>{languageData?.instantContactNotifications} </h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>
                  {languageData?.receiveImmediateInboxAlertsForEvery}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconThree} alt="icon" />
                <br /> <br />
                <h6>{languageData?.aIPoweredMarketing}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>

                  {languageData?.enjoyBestAutomatedMarketingThrough}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconFour} alt="icon" />
                <br /> <br />
                <h6>{languageData?.easyCancellationPolicy}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>
                  {languageData?.cancelAnytimeWithSeamlessHassle}
                </p>
              </div>
            </div>
          </div> <br />
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconFive} alt="icon" />
                <br /> <br />
                <h6>{languageData?.superiorPerformanceAndSpeed}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>
                  {languageData?.experienceFastLoadingTimesForAn}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconSix} alt="icon" />
                <br /> <br />
                <h6>{languageData?.seoOptimizedDesign}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>

                  {languageData?.improveYourSearchEngineRankings}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconSeven} alt="icon" />
                <br /> <br />
                <h6>{languageData?.enterpriseGradeSecurity}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>

                  {languageData?.protectYourSiteWithAdvanced}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0"> <br />
                <img src={RealtimeIconEight} alt="icon" />
                <br /> <br />
                <h6>{languageData?.reliableMultiCloudHosting}</h6> <br />
                <span style={{ display: 'block', width: '40%', margin: 'auto', borderBottom: '2px solid #ff671f' }}></span>
                <br />
                <p style={{ padding: '0 12px', margin: 0, fontSize: 16 }}>
                  {languageData?.ensureUptimeEvenDuringTrafficSpikes} </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="container text-left">
          <div style={{ background: 'linear-gradient(to bottom, #fff,  #fff, #ff671f)', padding: '2rem 0', borderRadius: 40 }}>
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-6 col-md-6">
                <div className="text-center">
                  <img src={SilloutVideo} alt="homepagemap" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div style={{ padding: '1rem' }} className="text-center-sm">
                  <h2 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand' }}>
                    {languageData?.weGotYouCoveredWithEssentialsYouNeed}
                  </h2>
                  <br />
                  <p style={pcustomwemake}>
                    {languageData?.weMakeSureThatYouGetAllTheMustHaveFeatures}
                  </p>
                  <br />
                  <Link to='/ourtemplate' style={{ color: 'inherit' }}>
                    <button style={{ marginTop: 20, marginBottom: 20 }}
                      className="btn play-btn"
                    >
                      {languageData?.ourTemplates} <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                    </button>
                  </Link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="text-center-sm welcome-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h2>{languageData?.ourMission}</h2> <br />
              <p style={{ fontSize: 17, fontWeight: 400, width: '100%' }}>
                {languageData?.atMyDigitalIndiaOurMissionIsToDigitizeIndia}
              </p>
              <br />
              <div className="gutter-space-2">
                <img src={OurMission} alt="logo" style={{ width: 'auto' }} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="text-center">
                {/* <img src={ProfileMission} alt="profile" style={{ width: '75%' }} /> */}
                <img src="/static/media/aboutprofile.ec82691f9b89f6e8c1d1.jpeg" alt="profile" className="home_image_about" style={{ borderRadius: '50%', marginBottom: 0, padding: '5px', border: '2px solid #ff671f' }} />
                <br />
                <div className="">
                  <div className="pl-sm-2" style={{ margin: 'auto', maxWidth: '100%' }}>
                    <div class="text-center form-margin-cst">
                      <h5 class="m-0">Khushbu Bhati</h5>
                      <p class="m-0" style={{ color: "rgb(255, 103, 31)", width: '100%' }}>Founder</p>
                      <p style={{ width: '100%', margin: 0 }}>MAXCODE IT SOLUTIONS PVT. LTD.</p>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-6">
                      <div style={{ paddingLeft: '7rem' }} className="pl-sm-2">
                        <h5 style={{ fontSize: 16, fontWeight: 600, textAlign: 'left', marginBottom: 0 }}>{languageData?.shriNarendraModi}</h5>
                        <p style={{ fontSize: 14, fontWeight: 500, textAlign: 'left', width: '200px' }}>{languageData?.honblepmOfIndia}</p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={{ paddingLeft: '2rem' }} className="pl-sm-2">
                        <h5 style={{ fontSize: 16, fontWeight: 600, textAlign: 'left', marginBottom: 0 }}>{languageData?.khushbuBhati}</h5>
                        <p style={{ fontSize: 14, fontWeight: 500, textAlign: 'left' }}>{languageData?.founder}</p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="container text-center">
          <h2 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', textAlign: 'center', margin: 'auto' }}>
            {languageData?.testimonials}
          </h2>
          <br />
          <p style={{ fontSize: 16, fontWeight: 500, maxWidth: 800, margin: 'auto', color: '#83817f' }}>{languageData?.discoverHowMyDigitalIndiaApp}</p>
          <br />
          <div style={{ textAlign: 'center', background: 'linear-gradient(to bottom, #fff,  #fff, #ff671f)', borderRadius: 40, padding: '4rem 2rem' }}>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0 text-left" style={{ padding: '1.2rem' }}>
                  <iframe width="100%" height="250" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=VGdzGa88MbgFDBtQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <br />
                  <img style={{ width: '100%', textAlign: 'left', maxWidth: 75, display: 'block' }} src="https://png.pngtree.com/png-vector/20220629/ourmid/pngtree-four-4-star-rank-sign-vector-illustration-eps10-png-image_5621249.png" alt="" />
                  <h6 style={{ textAlign: 'left', fontSize: 16, margin: 0 }}>Akriti Dubey</h6>
                  <p style={{ textAlign: 'left', fontSize: 13, marginBottom: 5 }}>Chartered Accountant </p>
                  <span style={{ display: 'block', width: '60%', borderBottom: '2px solid #ff671f' }}></span>
                  <br />
                  <p style={{
                    textAlign: 'left',
                    fontSize: 13,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: 3,
                    maxWidth: '300px'
                  }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0 text-left" style={{ padding: '1.2rem' }}>
                  <iframe width="100%" height="250" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=VGdzGa88MbgFDBtQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <br />
                  <img style={{ width: '100%', textAlign: 'left', maxWidth: 75, display: 'block' }} src="https://png.pngtree.com/png-vector/20220629/ourmid/pngtree-four-4-star-rank-sign-vector-illustration-eps10-png-image_5621249.png" alt="" />
                  <h6 style={{ textAlign: 'left', fontSize: 16, margin: 0 }}>Akriti Dubey</h6>
                  <p style={{ textAlign: 'left', fontSize: 13, marginBottom: 5 }}>Chartered Accountant </p>
                  <span style={{ display: 'block', width: '60%', borderBottom: '2px solid #ff671f' }}></span>
                  <br />
                  <p style={{
                    textAlign: 'left',
                    fontSize: 13,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: 3,
                    maxWidth: '300px'
                  }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0 text-left" style={{ padding: '1.2rem' }}>
                  <iframe width="100%" height="250" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=VGdzGa88MbgFDBtQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <br />
                  <img style={{ width: '100%', textAlign: 'left', maxWidth: 75, display: 'block' }} src="https://png.pngtree.com/png-vector/20220629/ourmid/pngtree-four-4-star-rank-sign-vector-illustration-eps10-png-image_5621249.png" alt="" />
                  <h6 style={{ textAlign: 'left', fontSize: 16, margin: 0 }}>Akriti Dubey</h6>
                  <p style={{ textAlign: 'left', fontSize: 13, marginBottom: 5 }}>Chartered Accountant </p>
                  <span style={{ display: 'block', width: '60%', borderBottom: '2px solid #ff671f' }}></span>
                  <br />
                  <p style={{
                    textAlign: 'left',
                    fontSize: 13,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: 3,
                    maxWidth: '300px'
                  }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="servc-cards animate__animated animate__fadeInLeft animate__delay-1s border-0 text-left" style={{ padding: '1.2rem' }}>
                  <iframe width="100%" height="250" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=VGdzGa88MbgFDBtQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <br />
                  <img style={{ width: '100%', textAlign: 'left', maxWidth: 75, display: 'block' }} src="https://png.pngtree.com/png-vector/20220629/ourmid/pngtree-four-4-star-rank-sign-vector-illustration-eps10-png-image_5621249.png" alt="" />
                  <h6 style={{ textAlign: 'left', fontSize: 16, margin: 0 }}>Akriti Dubey</h6>
                  <p style={{ textAlign: 'left', fontSize: 13, marginBottom: 5 }}>Chartered Accountant </p>
                  <span style={{ display: 'block', width: '60%', borderBottom: '2px solid #ff671f' }}></span>
                  <br />
                  <p style={{
                    textAlign: 'left',
                    fontSize: 13,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: 3,
                    maxWidth: '300px'
                  }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <h2>{languageData?.connectWithUsNowAndStartYourJourney}</h2>
            </div>
            <div className="col-lg-5">
              <div style={{ paddingLeft: '4rem', borderLeft: '3px solid #ff671f' }} className="pl-sm-2">
                <div className="text-center text-md-start">
                  <p style={{ fontSize: 32, fontWeight: 400, width: '100%', marginBottom: 0 }}>
                    {languageData?.haveAQuestion}
                  </p>
                  <button style={{ marginTop: 5, marginBottom: 5 }} className="btn play-btn">
                    <Link to='/faqs' style={{ color: 'inherit' }}>
                      {languageData?.helpCenter}<i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                    </Link>
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Home;